<div class="p-6" style="min-width: 300px;">

    <!-- Title -->
    <h2 class="text-center font-bold text-xl mb-5 orange-text">
        {{ isEditMode ? 'Edit Feature' : 'Add Feature' }}
    </h2>

    <div class="flex flex-col justify-center items-center gap-2">

        <!-- Feature Name (create mode only — immutable on edit) -->
        <div *ngIf="!isEditMode" class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                    [class.border-red-500]="isInvalid('name')"
                    [style.border-color]="isInvalid('name') ? '#e3342f' : ''">
                <span class="text-xs w-130-px font-semibold">Name:</span>
                <input
                    [formControl]="form.controls['name']"
                    type="text"
                    placeholder="Feature Name"
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3"
                >
            </div>
            <span *ngIf="getFieldError('name')"
                class="font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                {{ getFieldError('name') }}
            </span>
        </div>

        <!-- Feature Name read-only (edit mode) -->
        <div *ngIf="isEditMode" class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2">
                <span class="text-xs w-130-px font-semibold">
                    Name:
                </span>

                <span
                    class="flex items-center text-xs h-30-px font-semibold pl-3 cursor-not-allowed"
                >
                    {{ data.feature?.featureName }}
                </span>
            </div>
        </div>

        <!--
            Tiers to Allow
            Disabled when all tiers are already denied (nothing left to allow).
            Tooltip explains why it is locked.
        -->
        <div 
            style="width: 320px;"
            [matTooltip]="allowedDisabled ? 'All tiers are already denied.' : ''"
            matTooltipPosition="right"
            matTooltipClass="custom-orange-tooltip"
        >
            <app-dropdown-checklist-v2
                label="Tiers to Allow"
                [options]="allowedOptions"
                [selectedValues]="allowedSelectedValues"
                [showDefaultOption]="false"
                [disabled]="allowedDisabled"
                (selectionChange)="onAllowedChange($event)"
            />
        </div>

        <!--
            Tiers to Deny
            Disabled when all tiers are already allowed (nothing left to deny).
            Tooltip explains why it is locked.
        -->
        <div 
            style="width: 320px;"
            [matTooltip]="deniedDisabled ? 'All tiers are already allowed.' : ''"
            matTooltipPosition="right"
            matTooltipClass="custom-orange-tooltip"
        >
            <app-dropdown-checklist-v2
                label="Tiers to Deny"
                [options]="deniedOptions"
                [selectedValues]="deniedSelectedValues"
                [showDefaultOption]="false"
                [disabled]="deniedDisabled"
                (selectionChange)="onDeniedChange($event)"
            />
        </div>

        <div class="flex items-center justify-center px-4">
            <!-- Name validation error -->
            <span *ngIf="isInvalid('name')" 
                class="font-semibold text-center text-md" style="color: #e3342f;">
                Please apply the necessary corrections.
            </span>

            <!-- Tiers not yet assigned (create mode, after attempted save) -->
            <span *ngIf="!isInvalid('name') && !isEditMode && !allTiersAssigned && form.touched" 
                class="font-semibold text-center text-md" style="color: #e3342f;">
                Please assign a tier before saving.
            </span>

            <!-- API error (covers both create and edit, any message from the server) -->
            <span *ngIf="apiError && !isInvalid('name')" 
                class="font-semibold text-center text-md" style="color: #e3342f;">
                {{ apiError }}
            </span>
        </div>

    </div>

    <!-- Action buttons -->
    <div class="flex items-center justify-center gap-3 mt-6">
        <span
            [style.cursor]="!isFormValid ? 'not-allowed' : 'pointer'"
            [matTooltip]="!hasChanges ? 'No changes made' : (!isFormValid ? 'Please fill in all required fields' : '')"
            [matTooltipDisabled]="isFormValid"
            matTooltipPosition="left"
            matTooltipClass="custom-orange-tooltip"
        >
            <button
                (click)="store()"
                [disabled]="!isFormValid"
                class="uppercase custom-btn power-btn3 disabled-opacity active font-semibold text-sm"
                style="padding: 8px 12px;">
                {{ isEditMode ? 'Submit' : 'Save' }}
            </button>
        </span>
        <button
            (click)="close()"
            class="uppercase custom-btn power-btn3 font-semibold text-sm"
            style="padding: 8px 12px;">
            Cancel
        </button>
    </div>

</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>